import React from "react";
import {IMediaChecks} from "../services/media-query/media-queries.interface";

export const ScreenMediaQueriesChecksContext = React.createContext<IMediaChecks>(null!);